import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import( "../views/pc_index.vue"),
  },
  {
    path: "/news_detail",
    name: "news_detail",
    component: () => import( "../views/pc_news_detail.vue"),
  },
  {
    path: "/mobile",
    name: "mobile",
    component: () => import( "../views/mobile_index.vue"),
  },
  {
    path: "/mobile/news_detail",
    name: "mobile_news_detail",
    component: () => import( "../views/mobile_news_detail.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import( "../views/privacy_policy.vue"),
  },
  {
    path: "/about_us",
    name: "about_us",
    component: () => import( "../views/about_us.vue"),
  },
];



const router = createRouter({
  history: createWebHistory(),
  routes,
});



const isMobile = function () {
  // console.log('navigator.userAgent', navigator.userAgent)
  const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return screenWidth < 768 && flag  
}


router.beforeEach((to) => {
  if (isMobile() && to.name === 'home') {
    return '/mobile'
  } else if (!isMobile() && to.name === 'mobile') {
    return'/'
  }
})

export default router;
